import CarouselSection1 from './CarouselSection1';

export default CarouselSection1;